import { useState } from 'react';
import React from 'react';
import { MsgText } from './components/msg-text';
import { InqueryDetailPortal } from './components/inqiry-portal';
import { SysWrapper } from './components/wrapper';
import { SubMsgBaseProps } from '@/features/chat-messages/types/comp-block';
import { InquiryTaskCompleteSubMsg } from '@/features/chat-messages/types';

type InqueryTaskFinishSystemMsgProps = Pick<SubMsgBaseProps, 'dialogWrpperRef' | 'subMsg' | 'sessionId'>;
export const InqueryTaskFinishSystemMsg: React.FC<InqueryTaskFinishSystemMsgProps> = props => {
  const { dialogWrpperRef, subMsg, sessionId } = props;
  const { contentValue } = subMsg as InquiryTaskCompleteSubMsg;
  const [open, setOpen] = useState(false);
  return (
    <SysWrapper>
      <MsgText
        contentValue={contentValue}
        actions={[
          {
            triggerFieldKeys: ['taskName'],
            handleClick: () => {
              setOpen(true);
            },
          },
        ]}
      />
      <InqueryDetailPortal
        dialogWrpperRef={dialogWrpperRef}
        inquiryId={contentValue.inquiryTaskId}
        sessionId={sessionId}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      />
    </SysWrapper>
  );
};
